document.addEventListener('DOMContentLoaded', function () {
  var sliders = document.querySelectorAll('.accordion_slide');

  sliders.forEach(function (slider) {
    new Splide(slider, {
      type: 'slide',
      perPage: 4,
      autoplay: false,
      pagination: false,
      arrows: true, // still needed
      classes: {
        arrows: 'splide__arrows custom_arw',
        arrow: 'splide__arrow',
        prev: 'splide__arrow--prev',
        next: 'splide__arrow--next',
      },
      breakpoints: {
        500: {
          perPage: 2
        }
      }
    }).mount();
  });
});
